module.exports = __webpack_public_path__ + "img/未标题-1.38f84a61.png";